import { render } from "./jobDetailList.vue?vue&type=template&id=c29ab6e4&scoped=true&ts=true&lang=pug"
import script from "./jobDetailList.vue?vue&type=script&lang=ts"
export * from "./jobDetailList.vue?vue&type=script&lang=ts"

import "./jobDetailList.vue?vue&type=style&index=0&id=c29ab6e4&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29ab6e4"]])

export default __exports__